import React, { useState, useEffect, useReducer, useRef } from "react";
import { set, get } from "../../common/utils";
import {
  DataGrid,
  Column,
  Editing,
  Paging,
  Lookup,
  RequiredRule,
  FilterRow,
  Toolbar,
  Item,
  Export,SearchPanel
} from "devextreme-react/data-grid";
import { ScrollView } from "devextreme-react/scroll-view";
import sa3Reducer from "../../reducers/sa3";
import * as action from "../../actions/sa3";
import GapSolutionScatterChart from "./GapSolutionScatterChart";
import { postUserLog } from "../../actions/common";
import NEXUS_CONST from "../../common/constants";
import Button from "devextreme-react/button";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import { alert } from "devextreme/ui/dialog";
import { postLogForFilter, getPickStatus } from "./utils";
import { PICKSTATUSLOOKUP } from "./config";
import { isEmpty } from "lodash";

const initialStates = {
  a3GAPData: [],
  a3GAPSolutionData: [],
};

const GapSolution = (props: any) => {
  const [state, dispatch] = useReducer(sa3Reducer, initialStates);
  const { a3GAPSolutionData } = state;
  let {
    siteId,
    chartId,
    setisOpen,
    tierId,
    navigationOn,
    a3ID,
    handleA3Save,
    isDataSaved,
    activeTab
  } = props;
  const [isDisabled, setIsDisabled] = useState(true);
  const [rowVal, setRowVal] = useState(null);
  const dataGridRef = useRef<any>(null);
  const [a3GAPData, setA3GAPData] = useState<any>([]);
  const [distinctUsers, setDistinctUsers] = useState<any>([]);
  const [gridData, setGridData] = useState<any>([]);
  const [scrollConfig] = useState<any>({
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  });

  useEffect(() => {
    AsyncCallHandler(
      NEXUS_CONST.FETCH_A3_GAP_SOLUTION_DATA + a3ID,
      NEXUS_CONST.GET
    ).then((res) => {
      if (res) {
        setA3GAPData(res?.data[0]);
        setDistinctUsers(res?.data[1]);
        setGridData(res?.data[2]);
        AsyncCallHandler(
          NEXUS_CONST.FETCH_A3_DATA + a3ID,
          NEXUS_CONST.GET
        ).then((res) => {
          if (res) {
            setIsDisabled(res?.data?.status === "Complete");
          }
        });
      }
    });
  }, []);

  useEffect(() => {
    if (a3GAPSolutionData && a3GAPSolutionData.length > 0) setIsDisabled(false);
  }, [a3GAPSolutionData]);

  const onDiff = (v: any) => {
    let rowInd = get("saActivI");
    let benefit = dataGridRef?.current?.instance?.cellValue(rowInd, "benefit");
    dataGridRef?.current?.instance?.cellValue(rowInd, "difficulty", v.value);
    if (benefit)
      dataGridRef?.current?.instance?.cellValue(
        rowInd,
        "pickStatus",
        getPickStatus(benefit, v.value)
      );
  };

  const updateRowIndx = (e: any) => {
    set("saActivI", e.rowIndex);
    setRowVal(e.rowIndex);
  };

  let A3GAPData: any = [];
  A3GAPData = a3GAPData?.length < 0 || a3GAPData === undefined ? [] : a3GAPData;

  let DD =
    A3GAPData?.length > 0 &&
    A3GAPData.map((obj: any) => {
      return {
        value: `${obj.gapNumber}`,
        text: `${obj.gapDescription}`,
        id :  `${obj.gapId}`
      };
    });



  const onInitNewRow = React.useCallback((e: any) => {
    const numberOfRows =
      dataGridRef.current?.instance?.getVisibleRows()?.length || 0;

    e.data.gapId = a3GAPSolutionData.gapId;
    e.data.solution = "";
    e.data.solutionId = `A3${a3ID}-${numberOfRows + 1}`;
    e.data.expectedImprovement = "";
    e.data.owner = "";
    e.data.benefit = "";
    e.data.difficulty = "";
  }, []);

  const onBenefit = (v: any) => {
    let rowInd = get("saActivI");
    let diff = dataGridRef.current.instance.cellValue(rowInd, "difficulty");
    dataGridRef.current.instance.cellValue(rowInd, "benefit", v.value);
    if (diff)
      dataGridRef.current.instance.cellValue(
        rowInd,
        "pickStatus",
        getPickStatus(v.value, diff)
      );
  };

  const saveGapSolution = () => {
    dataGridRef.current?.instance?.saveEditData();
    if (gridData.length === 0) {
      alert("Please add at least one solution", "Alert");
      return false;
    } else {
      let data = {
        a3ID: a3ID,
        gapSolution: gridData,
        lastSaved: "5",
        tierId : tierId,
        section: props.activeTab
      };
      AsyncCallHandler(
        NEXUS_CONST.MANAGE_A3_GAP_SOLUTION_DATA,
        NEXUS_CONST.POST,
        data
      ).then((res) => {
        if (res) {
          AsyncCallHandler(
            NEXUS_CONST.FETCH_A3_GAP_SOLUTION_DATA + a3ID,
            NEXUS_CONST.GET
          ).then((res) => {
            if (res) {
              setA3GAPData(res?.data[0]);
              setDistinctUsers(res?.data[1]);
              setGridData(res?.data[2]);
              AsyncCallHandler(
                NEXUS_CONST.FETCH_A3_DATA + a3ID,
                NEXUS_CONST.GET
              ).then((res) => {
                if (res) {
                  setIsDisabled(res?.data?.status === "Complete");
                }
              });
            }
          });
          setisOpen("5");
          isDataSaved(5);
        }
      });
    }
    handleA3Save();
  };

  const renderCell = (data: any) => {
    let gapName = A3GAPData.find((c: any) => c.gapNumber == data.value);
    return (
      gapName && (
        <div title={`${gapName.gapNumber} - ${gapName.gapDescription}`}>
          {gapName.gapNumber}
        </div>
      )
    );
  };
  
  //Function to show tool tip for the dropdown
  const onEditorPreparing = (e: any) => {
    if (e.dataField === "gapid" && e.parentType === "dataRow") {
      e.editorOptions.onOpened = (args: any) => {
        const lookupInstance = args.component;

        if (lookupInstance._list) {
          const $lookupItems = lookupInstance._list
            .$element()
            .find(".dx-list-item-content");

          $lookupItems.each((index: any, element: any) => {
            const itemData = DD[index];
            const tooltipText = `${itemData.value}-${itemData.text}`;
            element.setAttribute("title", tooltipText);
          });
        }
      };
    }
  };

  function handleGridOptionChanged(e: any) {
    postLogForFilter(
      dataGridRef,
      e,
      siteId,
      tierId,
      "Solution Approach",
      5,
      a3ID,
      activeTab
    );
  }
  const initialstateConfig = {
    export: {
      enabled: true,
      fileName: "A3_SolutionApproach",
    },
  };

  return (
    <>
      <div className="title-section">
        {" "}
        <h2 className="sps_title">
          <span className="sps-print">Box 5 - &nbsp;</span>Solution Approach
        </h2>{" "}
        <div className="sps-save-btn save-btn">
          <Button
            style={{ float: "right", width: "140px", "margin-top": "3%" }}
            disabled={isDisabled}
            width={200}
            onClick={saveGapSolution}
            text="Save"
            type="normal"
          />
        </div>
      </div>
      <ScrollView
        width="100%"
        className="sps-box-s"
        height="420px"
        id="scrollview"
        {...scrollConfig}
      >
        <div className="site-body">
          <div className="solution-approach">
            <DataGrid
              ref={dataGridRef}
              id="gridContainer"
              dataSource={gridData}
              columnAutoWidth={true}
              allowColumnReordering={true}
              onInitNewRow={onInitNewRow}
              onCellClick={updateRowIndx}
              showBorders={true}
              {...initialstateConfig}
              onExporting={() =>
                postUserLog({
                  event: `Box 5 -Solution Approach Export`,
                  data: {
                    action: `Solution Approach exported for A3-${a3ID}`,
                    module: "Digital Tier",
                    section: props.activeTab,
                    siteUId: siteId,
                    widget: "Strategic A3",
                    tierId,
                  },
                })
              }
              wordWrapEnabled={true}
              onEditorPreparing={onEditorPreparing}
              width={"100%"}
              onOptionChanged={handleGridOptionChanged}
            >
              <Toolbar>
                <Item location="after" visible={true} name="addRowButton" />
                <Item location="after" visible={true} name="exportButton" />
                <Item location="after" visible={true} name="revertButton" />
                <Item name="searchPanel" visible={true} />
              </Toolbar>
              <Export enabled={true} />
              <Paging enabled={false} />
              <SearchPanel
                        visible={true}
                        onTextChange={(e) => {
                          if (!isEmpty(e)) {
                            postUserLog({
                              event: "Box 5 -Solution Approach Grid Search",
                              data: {
                                action: `${e} searched in solution approach grid A3-${props.a3ID}`,
                                module: "Digital Tier",
                                section: props.activeTab,
                                siteUId: props.siteId,
                                widget: "Strategic A3",
                                tierId: props.TierId,
                              },
                            });
                          }
                        }}
                      />
              <Editing mode="batch" allowUpdating={true} allowAdding={true} />
              <FilterRow visible={true} />
              <Column
                dataField="id"
               // caption="GAP #"
                width={70}
                cellRender={renderCell}
                minWidth={20}
                visible={false}
              ></Column>
              <Column
                dataField="gapid"
                caption="GAP #"
                minWidth={20}
                cellRender={renderCell}
              >
                 {" "}
                <RequiredRule />
                <Lookup dataSource={DD} valueExpr="value" displayExpr="value" />
              </Column>
              <Column
                dataField="solutionId"
                caption="Solution Id"
                allowEditing={false}
                minWidth={20}
              ></Column>
              <Column
                dataField="solution"
                caption="Solution"
                width={250}
                cssClass="WrappedColumn"
                minWidth={20}
              >
                {" "}
                <RequiredRule />
              </Column>
              <Column
                dataField="expectedImprovement"
                caption="Expected Improvement"
                cssClass="WrappedColumn"
                width={300}
                minWidth={20}
              >
                {" "}
                <RequiredRule />
              </Column>
              <Column
                dataField="owner"
                caption="Owner"
                width={120}
                minWidth={20}
                //editorOptions={ placeholder = "Your placeholder goes here..."}
              >
                <Lookup
                  dataSource={distinctUsers}
                  valueExpr="memberId"
                  displayExpr="memberName"
                />
                <RequiredRule />
              </Column>
              <Column
                dataField="benefit"
                caption="Benefit"
                width={80}
                minWidth={20}
                setCellValue={(r: any, v: any, cr: any)=>{
                  r.benefit = v;
                    let diff = cr.difficulty 
                    if (diff)
                      r.pickStatus = getPickStatus(v, diff)
              }}
              >
                <Lookup
                  dataSource={NEXUS_CONST.BenefitData}
                  valueExpr="value"
                  displayExpr="value"
                />{" "}
                <RequiredRule />
              </Column>
              <Column
                dataField="difficulty"
                caption="Difficulty"
                width={80}
                minWidth={20}
                setCellValue={(r: any, v: any, cr: any)=>{
                  r.difficulty = v;
                  let benefit = cr.benefit
                  if(benefit)
                  r.pickStatus = getPickStatus(benefit, v)
                }}
              >
                <Lookup
                  dataSource={NEXUS_CONST.DifficultyData}
                  valueExpr="value"
                  displayExpr="value"
                />{" "}
                <RequiredRule />
              </Column>
              <Column
                dataField="pickStatus"
                caption="PICK Status"
                allowEditing={false}
                minWidth={20}
              >
                <Lookup dataSource={PICKSTATUSLOOKUP} /> <RequiredRule />
              </Column>
              <Editing
                mode="batch"
                allowUpdating={true}
                allowAdding={true}
                allowDeleting={true}
                useIcons={true}
              />
            </DataGrid>
            {gridData && gridData.length > 0 ? (
              <div className="soln_chart">
                <GapSolutionScatterChart
                  a3GAPSolutionData={gridData}
                  chartId={chartId}
                />
                {setisOpen("5")}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </ScrollView>
    </>
  );
};

export default GapSolution;
